const initialState = {
  fetchCasesPending: true,
  fetchCasesFailure: false,
  newCase: false,
  caseRegionTemp: null,
  fetchCasesFeedback: null,
  filterCasesByTemplate: false,
  caseTemplates: [],
  cases: [],
  createCasePending: false,
  createCaseFeedback: null,
  updateCaseFeedback: null,
};

export default initialState;
